<template>
  <div data-base-equalizer-element="">
    <slot></slot>
  </div>
</template>
